
export default [{
	path: '/nlpgHome',
	component: () => import('../../views/nlpg/home'),
	redirect: '/nlpgHome/archives',
	children: [{
		path: 'archives',
		component: () => import('../../views/nlpg/archives/index')
	},
	{
		path: 'archivesAssessment',
		component: () => import('../../views/nlpg/archives/assessment/home'),
		redirect: 'archivesAssessment/index',
		children: [{
			path: 'index',
			component: () => import('../../views/nlpg/archives/assessment/index'),
		},
		{
			path: 'openTable',
			component: () => import('../../views/nlpg/archives/assessment/openTable'),
		},
		{
			path: 'rcshhdgn',
			component: () => import('../../views/nlpg/archives/assessment/rcshhdgn/index'),
		},
		{
			path: 'smpsbsmzl',
			component: () => import('../../views/nlpg/archives/assessment/smpsbsmzl/index'),
		},
		{
			path: 'jwicu',
			component: () => import('../../views/nlpg/archives/assessment/jwicu/index'),
		},
		{
			path: 'cdjmjszt',
			component: () => import('../../views/nlpg/archives/assessment/cdjmjszt/index'),
		},
		{
			path: 'cdmoca',
			component: () => import('../../views/nlpg/archives/assessment/cdmoca/index'),
		},
		{
			path: 'mmse',
			component: () => import('../../views/nlpg/archives/assessment/mmse/index'),
		},
		{
			path: 'tyxhdphzxlb',
			component: () => import('../../views/nlpg/archives/assessment/tyxhdphzxlb/index'),
		},
		{
			path: 'lnrnlpg',
			component: () => import('../../views/nlpg/archives/assessment/lnrnlpg/index'),
		}, {
			path: 'pdfTabletylxpjbz',
			component: () => import('../../views/nlpg/archives/assessment/pdfTabletylxpjbz/index')
		}, {
			path: 'pdfTablexfsyweb',
			component: () => import('../../views/nlpg/archives/assessment/pdfTablexfsyweb/index')
		}, {
			path: 'pdfTablewsjyy',
			component: () => import('../../views/nlpg/archives/assessment/pdfTablewsjyy/index')
		}, {
			path: 'pdfTablewsjyj',
			component: () => import('../../views/nlpg/archives/assessment/pdfTablewsjyj/index')
		}, {
			path: 'pdfTablejygnzasc',
			component: () => import('../../views/nlpg/archives/assessment/pdfTablejygnzasc/index')
		}, {
			path: 'pdfTablewsncb',
			component: () => import('../../views/nlpg/archives/assessment/pdfTablewsncb/index')
		}, {
			path: 'pdfTablewscsb',
			component: () => import('../../views/nlpg/archives/assessment/pdfTablewscsb/index')
		}, {
			path: 'pdfTablenczhyydmszd',
			component: () => import('../../views/nlpg/archives/assessment/pdfTablenczhyydmszd/index')
		}, {
			path: 'pdfTablestmptxz',
			component: () => import('../../views/nlpg/archives/assessment/pdfTablestmptxz/index')
		}, {
			path: 'pdfTablestmptsz',
			component: () => import('../../views/nlpg/archives/assessment/pdfTablestmptsz/index')
		}
		]
	},
	{
		path: 'personalCenter',
		component: () => import('../../views/nlpg/personalCenter/index.vue'),
		redirect: 'personalCenter/report',
		meta: {
			title: '个人中心'
		},
		children: [
			{
				path: 'report',
				component: () => import('../../views/nlpg/personalCenter/report/index')
			},
			{
				path: 'studylogs_examAssessment',
				component: () => import('../../views/nlpg/personalCenter/studylogs/index')
			}
		]
	},
	{
		path: 'exam',
		component: () => import('../../views/nlpg/practicalTraining/index')
	},
	{
		path: 'examAssessment',
		component: () => import('../../views/nlpg/practicalTraining/assessment/home')
	}
	]
}
	// {
	// 	path: '/nnahome',
	// 	component: () => import('../../views/nna/home'),
	// 	redirect: '/nnahome/exam',
	// 	children: [
	// 		{
	// 			path: 'exam',
	// 			component: () => import('../../views/lnrnlpg/practicalTraining/index')
	// 		},
	// 		{
	// 			path: 'examAssessment',
	// 			component: () => import('../../views/lnrnlpg/practicalTraining/assessment/home')
	// 		},
	// 		// {
	// 		// 	path: 'personalCenter',
	// 		// 	component: () => import('../../views/nna/personalCenter/index.vue'),
	// 		// 	redirect: 'personalCenter/report',
	// 		// 	meta: {
	// 		// 		title: '个人中心'
	// 		// 	},
	// 		// 	children: [
	// 		// 		{
	// 		// 			path: 'report',
	// 		// 			component: () => import('../../views/lnrnlpg/personalCenter/report/index')
	// 		// 		},
	// 		// 		{
	// 		// 			path: 'studylogs_examAssessment',
	// 		// 			component: () => import('../../views/lnrnlpg/personalCenter/studylogs/index')
	// 		// 		}
	// 		// 	]
	// 		// }
	// 	]
	// }
]